const messages = {
  confirmations: {
    DELETE_USER_TITLE: 'Delete User',
    DELETE_USER_MSG: 'Are you sure you want to delete ',
    PENDING_USER_NAME: '<registration email sent>',
    REMOVE_USER_FROM_GROUP_MGS: 'Are you sure you want to remove ',
    RESEND_VERIFY_EMAIL_TITLE: 'Verify User',
    RESEND_VERIFY_EMAIL_MSG: 'Do you want to resend a verification email to ',
    RESET_PASSWORD_TITLE: 'Reset Password',
    RESET_PASSWORD_MSG1: 'Do you want to send an email to ',
    RESET_PASSWORD_MSG2: ' to reset the password?',
  },
  pageHeaders: {
    CHANGE_PASSWORD_TITLE: 'Change Password',
    GROUPS_PAGE_MSG: 'Manage user groups including creating, adding & removing users.',
    LOGGED_OUT_TITLE: 'Logged Out',
    PERMISSIONS_PAGE_MSG: 'Permissions are a mechanism to formally create a user permission and associate it with an application. Examples include read-only or edit.',
    RESET_PASSWORD_TITLE: 'Reset Password',
    ROLES_PAGE_MSG: 'Roles are a secure way to grant permissions to entities that you trust. Select an application and permission(s).',
    SECURITY_CHALLENGE_TITLE: 'Security Challenge',
    UNAUTHORIZED_TITLE: 'Unauthorized',
    USER_REGISTRATION_TITLE: 'User Registration',
    USERS_PAGE_MSG: 'Manage user identities including creating, provisioning, and deleting users. Also, enables administrators to reset passwords.',
  },
  pageMessages: {
    RESET_PASSWORD_EXPIRATION_MSG: 'The ability to reset your password has expired. Please contact your partner administrator.',
    LOGGED_OUT_MSG1: 'You\'re logged out of Partner Access.',
    LOGGED_OUT_MSG2: 'Sign in again',
    PASSWORD_CHANGED_MSG: 'Password was successfully changed.',
    REGISTRATION_COMPLETE_MSG: 'Your registration with your partner(s) is complete.',
    REGISTRATION_EXPIRATION_MSG: 'User registration with your partner has expired. Please contact your partner administrator.',
    SECURITY_QUESTION_MISSING_MSG: 'Please contact your partner administrator to reset your password.',
    SECURITY_QUESTION_REMINDER_MSG: 'In order to reset your password yourself in the future, please set a security question on the profile page in Partner Access.',
    SECURITY_CHALLENGE_MSG: 'We need to make sure it\'s really you.',
    SECURITY_CHALLENGE_FORGOT_MSG: 'If you do not recall your security question answer, please contact your Partner administrator.',
    SELF_SERVICE_RESET_PASSWORD_EXPIRATION_MSG: 'The ability to reset your password has expired. To send a fresh reset email, visit the forgot password link on your login page or contact your partner administrator.',
    SUPPLIER_REPORTS_URL_MSG: 'The new Supplier Reports can be accessed via the URL provided below.',
    UNAUTHORIZED_MSG: 'Sorry, you\'re not authorized to view this page. Please contact your Partner administrator,',
    UNAUTHORIZED_MSG_LOGOUT: 'or logout and try again',
    VENDORS_TERMS_MSG1: 'By registering your account, you agree to the ',
    VENDORS_TERMS_LINK: 'Supplier Reports User Agreement',
    VENDORS_TERMS_MSG2: '.'
  },
  notificationMessages: {
    ADMIN_EMAIL: 'your administrator',
    GROUP_CREATED_MSG: 'Group was successfully created',
    GROUP_DELETED_MSG: 'Group was successfully deleted',
    GROUP_UPDATED_MSG: 'Group was successfully updated',
    GROUP_USER_REMOVED_MSG: 'User successfully removed from group',
    PASSWORD_RESET_EMAIL_SENT_MSG: 'Reset password email sent',
    PERMISSON_CREATED_MSG: 'Permission was successfully created',
    PERMISSON_DELETED_MSG: 'Permission was successfully deleted',
    PERMISSON_UPDATED_MSG: 'Permission was successfully updated',
    VERIFICATION_EMAIL_SENT_MSG: 'Verification email sent',
    ROLE_ADDED_TO_USER_MSG: 'Role was succesfully added to user',
    ROLE_CREATED_MSG: 'Role was successfully created',
    ROLE_DELETED_MSG: 'Role was successfully deleted',
    ROLE_UPDATED_MSG: 'Role was successfully updated',
    SECURITY_QUESTION_SET_MSG: 'Security question was successfully set',
    USER_CREATED_MSG: 'User was successfully created',
    USER_DELETED_MSG: 'User was successfully deleted',
    USERS_GROUP_UPDATED_MSG: 'User\'s groups have been successfully updated',
    USERS_ROLE_UPDATED_MSG: 'User\'s roles have been successfully updated',
  },
  tooltips: {
    CHANGE_PASSWORD_EMAIL: 'Send change password email',
    DELETE_USER_DISABLED: 'Can\'t delete a user assosciated with multiple partners',
    DELETE_PERMISSION_DISABLED: 'Can\'t delete a permission attached to a role',
    EDIT_PERMISSION_DISABLED: 'Can\'t edit a permission attached to a role',
    INVITATION_EMAIL: 'Resend invitation email',
    PASSWORD_POLICY1: '16 characters in length (minimum)',
    PASSWORD_POLICY2: 'Does not contain first name',
    PASSWORD_POLICY3: 'Does not contain last name',
    PASSWORD_POLICY4: 'Does not contain part of email',
    PERSON_ADD: 'Add user to group',
    SECURITY_QUESTIONS_POLICY1: '4 characters in length (minimum)',
    SECURITY_QUESTIONS_POLICY2: 'Does not contain part of email',
    SECURITY_QUESTIONS_POLICY3: 'Does not contain password',
    SECURITY_QUESTIONS_POLICY4: 'Is not a word in the security question',
    EDIT: 'Edit',
    DELETE: 'Delete',
    REMOVE: 'Remove'
  },
  uiComponents: {
    NOT_FOUND_1: 'The page you\'re trying to reach cannot be found.',
    NOT_FOUND_2: 'Please visit our ',
    NOT_FOUND_3: ', or contact your administrator for further guidance.',
    ADD_ROLE_TO_USER_BUTTON: 'Add Role To User',
    ADD_ROLE_TO_GROUP_BUTTON: 'Add Role To Group',
    ADD_USER_BUTTON_LABEL: 'ADD USER',
    ADD_USER_DIALOG_TITLE: 'Add New User',
    ADD_USER_TO_GROUP_SELECT_FIELD: 'New Users',
    ADD_USER_TO_GROUP_TITLE: 'Add User To Group',
    ADDING_ROLE_MSG: 'Adding role...',
    ADDING_USER_MSG: 'Adding user...',
    ADMIN_DIALOG_CLOSE_BUTTON_LABEL: 'Close',
    ADMIN_LIST_EMAIL: 'Email',
    ADMIN_LIST_FIRST_NAME: 'First Name',
    ADMIN_LIST_LAST_NAME: 'Last Name',
    ADMIN_LIST_TITLE: 'My Admins',
    ADMIN_RADIO: 'Admin',
    APP_CONTEXT_NO_PARTNERS: 'all partners shown, click to filter on partner(s)',
    APP_CONTEXT_TITLE: 'Application Context',
    APP_CONTEXT_SELECT_LABEL: 'Application',
    APP_CONTEXT_INPUT_LABEL: 'Partner Ids(comma seperated)',
    APPLICATION_NAME: 'Partner Access',
    APPLICATION_NAME_FIELD: 'Application Name',
    ANSWER_LABEL: 'Answer',
    AUTHORIZING_MSG: 'Authorizing ...',
    CHANGE_BUTTON: 'Change',
    CHANGE_PASSWORD_LABEL: 'Change Password',
    CHANGE_SECURITY_QUESTION_TITLE: 'Change Security Question',
    CREATE_GROUP_BUTTON: 'Create Group',
    CREATE_GROUP_TITLE: 'Create New Group',
    CREATE_PERMISSION_BUTTON: 'Create Permission',
    CREATE_PERMISSION_TITLE: 'Create New Permission',
    CREATE_ROLE_BUTTON: 'Create Role',
    CREATE_ROLE_TITLE: 'Create New Role',
    CREATING_MSG: 'Creating...',
    CURRENT_PASSWORD_LABEL: 'Current Password',
    DELETE_GROUP_TITLE: 'Delete Group',
    DELETE_PERMISSION_TITLE: 'Delete Permission',
    DELETE_ROLE_TITLE: 'Delete Role',
    DELETING_GROUP_MSG: 'Deleting group...',
    DELETING_PERMISSION_MSG: 'Deleting permission...',
    DELETING_ROLE_MSG: 'Deleting role...',
    DELETING_USER_MSG: 'Deleting user...',
    EDIT_GROUP_TITLE: 'Update Group',
    EDIT_PERMISSION_TITLE: 'Update Permission',
    EDIT_ROLE_TITLE: 'Update Role',
    EDIT_USERS_ROLE_TITLE1: 'Manage ',
    EDIT_USERS_ROLE_TITLE2: '\'s roles',
    EMAIL_INPUT_FIELD: 'Email',
    EMAIL_LABEL: 'Email',
    FIRST_NAME_INPUT_FIELD: 'First Name',
    FORM_DIALOG_CANCEL_BUTTON_LABEL: 'Cancel',
    FORM_DIALOG_SUBMIT_BUTTON_LABEL: 'Submit',
    GROUP_APPLICATION_SELECT_FIELD: 'Application',
    GROUP_DESCRIPTION_INPUT_FIELD: 'Description',
    GROUP_DROPDOWN_FIELD: 'Groups',
    GROUP_NAME_INPUT_FIELD: 'Group Name',
    GROUP_PARTNER_SELECT_FIELD: 'Partner',
    GROUP_SEARCH_LABEL: 'Search across all partners by group name',
    GROUP_REMOVE_USER_INPUT_FIELD:'Remove User From Group',
    GROUP_ROLE_SELECT_FIELD: 'Role(s)',
    LAST_NAME_INPUT_FIELD: 'Last Name',
    LOADING_MSG: 'Loading...',
    LOGOUT_LABEL: 'Logout',
    NAME_LABEL: 'Name',
    NEW_PASSWORD_LABEL: 'New Password',
    NEW_PASSWORD_CONFIRMATION: 'Confirm New Password',
    NO_GROUPS_ASSOSCIATED_WITH_PARTNER: 'No groups assosciated with this Partner Id. Please Create a group.',
    NO_PERMISSION_SELECT_FIELD: 'No permissions found for this application',
    NO_VALID_PARTNER_ID: 'Enter a valid Partner Id',
    PA_DROPDOWN_NO_GROUPS: 'Partner not selected / Partner has no assosciated groups.',
    PASSWORD_REQUIREMENTS_LABEL: 'Requirements:',
    PARTNER_ID_INPUT_FIELD: 'Partner Id',
    PARTNER_NAME_INPUT_FIELD: 'Partner Name',
    PERMISSIONS_NAME_INPUT_FIELD: 'Permission Name',
    PERMISSIONS_DESCRIPTION_INPUT_FIELD: 'Description',
    PERMISSIONS_APPLICATION_SELECT_FIELD: 'Application',
    PROFILE_MENU_ITEM: 'Profile',
    REGISTRATION_FIRST_NAME_INPUT_FIELD: 'First Name',
    REGISTRATION_LAST_NAME_INPUT_FIELD: 'Last Name',
    REGISTRATION_PASSWORD_INPUT_FIELD: 'Password',
    REGISTRATION_CONFIRM_PASSWORD_INPUT_FIELD: 'Confirm Password',
    REGISTRATION_SUBMIT_BUTTON: 'Register',
    RESET_PASSWORD_BUTTON: 'Reset',
    ROLES_NAME_INPUT_FIELD: 'Role Name',
    ROLES_DROPDOWN_FIELD: 'Select Roles',
    ROLES_DESCRIPTION_INPUT_FIELD: 'Description',
    ROLES_APPLICATION_SELECT_FIELD: 'Application',
    ROLES_PERMISSION_SELECT_FIELD: 'Permission',
    SECURITY_CHALLENGE_BUTTON_LABEL: 'Submit',
    SECURITY_QUESTION_LABEL: 'Security Question',
    SENDING_EMAIL_MSG: 'Sending...',
    SET_SECURITY_QUESTION_BUTTON: 'Set',
    SET_SECURITY_QUESTION_TITLE: 'Set Security Question',
    SHOW_MY_ADMINS: 'My Administrators',
    SIDE_NAV_GROUPS: 'Groups',
    SIDE_NAV_PERMISSIONS: 'Permissions',
    SIDE_NAV_PROFILE: 'My Profile',
    SIDE_NAV_ROLES: 'Roles',
    SIDE_NAV_USERS: 'Users',
    TAB_PROFILE: 'Profile',
    TAB_GROUPS: 'Groups',
    TAB_USERS: 'Users',
    TAB_ROLES: 'Roles',
    TABLE_APPLICATION_ID_COLUMN: 'Application ID',
    TABLE_DESCRIPTION_COLUMN: 'Description',
    TABLE_EMAIL_COLUMN: 'Email',
    TABLE_USERS_COLUMN: 'Users',
    TABLE_NAME_COLUMN: 'Name',
    TABLE_ROLES_COLUMN: 'Roles',
    TABLE_STATUS_COLUMN: 'Status',
    TABLE_USER_NAME_COLUMN: 'User Name',
    TABLE_PARTNER_NAME_COLUMN: 'Partner',
    TABLE_PARTNER_ID_COLUMN: 'Partner ID',
    REMOVE: 'Remove',
    REMOVING_MSG: 'Removing...',
    UPDATING_MSG: 'Updating...',
    USER_SEARCH_LABEL: 'Search across all partners by email address',
    USER_RADIO: 'User'
  },
  fieldErrors: {
    CAN_NOT_CONTAIN_EMAIL: 'can not include part of email',
    CAN_NOT_CONTAIN_FIRST_NAME: 'can not include first name',
    CAN_NOT_CONTAIN_LAST_NAME: 'can not include last name',
    CAN_NOT_CONTAIN_PASSWORD: 'can not include password',
    CAN_NOT_BE_QUESTION_PART: 'can not be a word from the question',
    EMAIL: 'invalid email address',
    EMAIL_DOMAIN: 'cannot be a nordstrom email domain address',
    LOOKUP_REQUIRED: 'invalid partner Id',
    MAX_LENGTH: 'must be 50 characters or less',
    MIN_LENGTH: 'must be 4 characters or more',
    PASSWORD_STRENGTH: 'password has too few characters',
    PASSWORD_MATCH: 'passwords don\'t match',
    REQUIRED: 'required',
  },
  systemErrors: {
    PA1: '[PA1] A service error occurred. Try again and if you\'re still seeing the issue, please email ',
    PA2: '[PA2] An issue has occurred while removing the user from this group. Try again and if you\'re still seeing the issue, please email ',
    PA3: '[PA3] An issue has occurred while removing the user from this role. Try again and if you\'re still seeing the issue, please email ',
    PA4: '[PA4] An issue has occurred while creating the permission. Try again and if you\'re still seeing the issue, please email ',
    PA5: '[PA5] An issue has occurred while updating the permission. NOTE: Permissions in use by roles cannot be updated. Try again and if you\'re still seeing the issue, please email ',
    PA6: '[PA6] An issue has occurred while deleting the permission. NOTE: Permissions in use by roles cannot be deleted. Try again and if you\'re still seeing the issue, please email ',
    PA7: '[PA7] An issue has occurred while creating the role. Try again and if you\'re still seeing the issue, please email ',
    PA8: '[PA8] An issue has occurred while updating the role. Try again and if you\'re still seeing the issue, please email ',
    PA9: '[PA9] An issue has occurred while updating the group. Try again and if you\'re still seeing the issue, please email ',
    PA10: '[PA10] An issue has occurred while deleting the role. Try again and if you\'re still seeing the issue, please email ',
    PA11: '[PA11] An issue has occurred while updating the user\'s groups. Try again and if you\'re still seeing the issue, please email ',
    PA12: '[PA12] An issue has occurred while fetching the groups. Try again and if you\'re still seeing the issue, please email ',
    PA13: '[PA13] An issue has occurred while creating the group. Try again and if you\'re still seeing the issue, please email ',
    PA14: '[PA14] An issue has occurred while deleting the group. Try again and if you\'re still seeing the issue, please email ',
    PA15: '[PA15] An issue has occurred with a call to NAuth Authorization API. Try again and if you\'re still seeing the issue, please email ',
    PA16: '[PA16] An issue has occurred while updating the user. Try again and if you\'re still seeing the issue, please email ',
    PA17: '[PA17] An issue has occurred with your password. Try a different password and if you\'re still seeing the issue, please email ',
    PA18: '[PA18] An issue with sending reset password email. Try again and if you\'re still seeing the issue, please email ',
    PA19: '[PA19] An issue with resend verification email. Try again and if you\'re still seeing the issue, please email ',
    PA20: '[PA20] An issue has occurred while setting your security question. Try again and if you\'re still seeing the issue, please email ',
    PA21: '[PA21] An issue has occurred while fetching security questions. Try again and if you\'re still seeing the issue, please email ',
    PA22: '[PA22] An issue has occurred verifying your security answer. Try again and if you\'re still seeing the issue, please email ',
    PA23: '[PA23] An issue has occurred while fetching your applications. Try again and if you\'re still seeing the issue, please email '
  },
  userErrors: {
    CHANGE_PASSWORD: 'Your current password is incorrect and/or you must choose a different new password.',
    FORGOT_PASSWORD: 'Your security answer is incorrect and/or you must choose a different new password.',
  }
}

export default messages
